import { localStorageSync } from 'ngrx-store-localstorage';
import { ActionReducer } from '@ngrx/store';
import { PractiseState } from './practise.reducer';

export function practiseLocalStorageSyncReducer(
  reducer: ActionReducer<PractiseState>,
): ActionReducer<PractiseState> {
  return localStorageSync({
    keys: ['selectedPractiseType'],
    rehydrate: true,
    removeOnUndefined: true,
    storageKeySerializer: (key) => `__lyceo-app/practise/${key}`,
  })(reducer);
}
